import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { adApi } from '../../../api/ad.api';
import { Card, CardContent, CardHeader } from '../../ui/card';
import { ChevronDown, ChevronUp } from 'lucide-react';
import RewardConfigSnapshot from './RewardConfigSnapshot';
import AdPositionSnapshot from './AdPositionSnapshot';
import DeploymentTimeline from './DeploymentTimeline';
import AdIdAggregationTable from './AdIdAggregationTable';

/**
 * G1-2: 운영 설정 스냅샷 + 배포 타임라인 + 광고ID별 집계
 * - AdPerformanceDashboard 상단에 접힘 섹션으로 배치
 * - S11-6 baseline 관측 + kill switch 판정 근거 제공
 * - 읽기 전용. 설정 편집은 기존 페이지(TossAdConfig / TossRewardAdConfig)
 */
const OpsSnapshot = () => {
  const [expanded, setExpanded] = useState(true);

  const { data: snapshot, isLoading } = useQuery({
    queryKey: ['opsSnapshot'],
    queryFn: () => adApi.getOpsSnapshot().then((res) => res.data),
    staleTime: 1000 * 60 * 60,
    enabled: expanded,
  });

  return (
    <Card className="mb-4 border-blue-200">
      <CardHeader className="py-2">
        <div className="flex items-center justify-between cursor-pointer" onClick={() => setExpanded(!expanded)}>
          <div className="flex items-center gap-2">
            <span className="text-sm font-semibold">📊 운영 설정 스냅샷 (G1-2)</span>
            <span className="text-[10px] text-gray-500">
              터치포인트 비율 · 배너 광고ID · 배포 타임라인 · 광고ID 집계
            </span>
          </div>
          {expanded ? (
            <ChevronUp className="w-4 h-4 text-gray-500" />
          ) : (
            <ChevronDown className="w-4 h-4 text-gray-500" />
          )}
        </div>
      </CardHeader>

      {expanded && (
        <CardContent className="space-y-5 pt-0">
          {isLoading ? (
            <div className="text-xs text-gray-400">로딩 중...</div>
          ) : !snapshot ? (
            <div className="text-xs text-red-500">데이터를 불러오지 못했습니다.</div>
          ) : (
            <>
              <RewardConfigSnapshot configs={snapshot.rewardAdConfigs} />
              <AdPositionSnapshot
                positions={snapshot.positionConfigs}
                todayLimitReached={snapshot.todayLimitReachedByPosition}
              />
            </>
          )}
          <DeploymentTimeline />
          <AdIdAggregationTable />
        </CardContent>
      )}
    </Card>
  );
};

export default OpsSnapshot;
